import { entitlementIndexQueryOptions, type SubscriptionAccessData } from '@jobilla/nexus-sdk'
import type { QueryClient } from '@tanstack/react-query'
import { redirect } from '@tanstack/react-router'

const OPEN_PATHS = ['subscribe', 'settings/billing', 'settings/subscribe', 'settings/invoices', 'settings/wallet']

export function isOpenWithoutSubscription(pathname: string, companyId: string): boolean {
	const path = pathname.replace(/\/+$/, '')

	return OPEN_PATHS.some((openPath) => path === `/company/${companyId}/${openPath}`)
}

export function isBlocked(access: SubscriptionAccessData | null | undefined): boolean {
	return access?.hasAccess === false
}

export const subscriptionGuard = async (
	queryClient: QueryClient,
	{ jobillaOrgId, companyId, pathname }: { jobillaOrgId: string; companyId: string; pathname: string },
): Promise<void> => {
	if (isOpenWithoutSubscription(pathname, companyId)) {
		return
	}

	let entitlements
	try {
		entitlements = await queryClient.ensureQueryData(entitlementIndexQueryOptions(jobillaOrgId))
	} catch {
		// Nexus enforces access on its own, so a failed check must not lock the app.
		return
	}

	if (isBlocked(entitlements.subscriptionAccess)) {
		throw redirect({ to: '/company/$companyId/subscribe', params: { companyId } })
	}
}
